<div class="content-bar">
  <div class="displayFlex">
    <div class="displayFlex contentTitle">
      <p class="textAlert bold">Número de alertas reasignadas</p>
    </div>
    <button
      (click)="selected = 'Diario'; getDay()"
      [ngClass]="{ selectedClass: selected == 'Diario' }"
      mat-stroked-button
    >
      Diario
    </button>
    <button
      (click)="selected = 'Semanal'; getWeek()"
      [ngClass]="{ selectedClass: selected == 'Semanal' }"
      mat-stroked-button
      class="margin-side"
    >
      Semanal
    </button>
    <button
      (click)="selected = 'Mensual'; getYear()"
      [ngClass]="{ selectedClass: selected == 'Mensual' }"
      mat-stroked-button
    >
      Mensual
    </button>
  </div>

  <div>
    <div class="divChart" #reasignedContentLine id="reasignedContentLine">
      <canvas
        #reasigned
        id="reasigned"
        height="300"
        style="height: 360px"
      ></canvas>
    </div>
  </div>
</div>
